/******************************************************************************
 * @Author                : Jbristhuille<jbristhuille@gmail.com>              *
 * @CreatedDate           : 2024-11-05 12:32:46                               *
 * @LastEditors           : Jbristhuille<jbristhuille@gmail.com>              *
 * @LastEditDate          : 2024-12-11 10:20:44                               *
 *****************************************************************************/

/* SUMMARY
  * Imports
  * DateDisplay: customer display component
*/

/* Imports */
import { format } from "date-fns";
import { GenericDisplay, GenericDisplayProps } from "../00-generic/GenericDisplay";
/***/

/*
* DateDisplay: customer display component
* Used to display a customer entity
*/

export interface DateDisplayProps extends GenericDisplayProps {
  date: Date
}

class DateDisplay extends GenericDisplay<DateDisplayProps> {
  getData = (() => {
    return format(new Date(this.props.date), "dd/MM/yyyy");
  });
}

export default DateDisplay;
/***/